<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 文件系统</el-breadcrumb-item>
                <el-breadcrumb-item> 数据</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.type' placeholder='类型'>
                                    <el-option
                                        v-for='item in exportTypeList'
                                        :key='item'
                                        :label='item'
                                        :value='item'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.status' placeholder='任务状态'>
                                    <el-option
                                        v-for='item in exportTaskStatusOptions'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='exportTaskList'
                      @selection-change='handleSelectionChange'>
                <el-table-column fixed align='center'>
                    <template slot-scope='scope'>
                        <el-avatar shape='square' size='small'>{{ computeFileType(scope.row, new Date().getTime()) }}
                        </el-avatar>
                    </template>
                </el-table-column>
                <el-table-column fixed :show-overflow-tooltip='true' align='center' width='250px' label='Title'
                                 prop='title' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='文件大小'>
                    <template slot-scope='scope'>
                        <span>{{ computeFileSize(scope.row, new Date().getTime()) }}</span>
                    </template>
                </el-table-column>
                <el-table-column width='100' align='center' label='任务状态'>
                    <template slot-scope='scope'>
                        <span>
                            {{ computeTaskStatus(scope.row, new Date().getTime()) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column width='70' align='center' label='进度'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.progress ? (scope.row.progress * 100).toFixed(2) : 0 }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' width='250px' label='失败原因'
                                 prop='failureReason' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='下载地址'>
                    <template slot-scope='scope'>
                        <el-button v-if='computeShowDownloadBut(scope.row, new Date().getTime())' type='text'
                                   size='mini' @click='handleCopyUrl(scope.row.downloadUrl)'>复制
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='详情'>
                    <template slot-scope='scope'>
                        <el-button type='text' size='mini' @click='handleViewDetail(scope.row)'>查看</el-button>
                    </template>
                </el-table-column>
                
                <el-table-column align='center' width='200' label='创建时间' prop='createTime' />
                <el-table-column align='center' width='200' label='完成时间' prop='finishTime' />
                <el-table-column fixed='right' align='center' width='300' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-download'
                            size='mini'
                            type='text'
                            v-if='computeShowDownloadBut(scope.row, new Date().getTime())'
                            @click='handleDownloadFile(scope.row)'
                        >下载
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            v-if='computeRetryUpload(scope.row, new Date().getTime())'
                            @click='handleRetryUpload(scope.row)'
                        >重试上传
                        </el-button>
                        <el-button
                            icon='el-icon-remove-outline'
                            size='mini'
                            type='text'
                            style='color: #F56C6C'
                            v-if='scope.row.status === 0 && !scope.row.terminalStatus'
                            @click='handleTerminalTask(scope.row)'
                        >终止
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='createSameExportTask(scope.row)'
                        >创建相同任务
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <el-dialog :visible.sync='open' append-to-body width='40%'>
                <vue-json-pretty :data='currentExportTask.detailJson' />
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';
import { copyContent } from '@/utils/string/cottonPlugin';
import { FileUtils } from '@/utils/file';
import { fileWebApi } from '@/components/api/File/fileWeb';
import CottonFileUpload from '@/components/component/CottonFileUpload.vue';
import { exportTrackDataApi } from '@api/Track/exportTrackData';
import { exportTaskApi } from '@api/ExportTask/exportTask';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    name: 'Dict',
    components: { CottonFileUpload, VueJsonPretty },
    data() {
        return {
            uploadData: {
                saveFolder: '/vue/kaudhf',
                accessType: 'PUBLIC'
                
            },
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            uploadOpen: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                
                type: undefined,
                status: undefined,
                sortSqlList: [
                    'createTime desc'
                ]
            },
            updateStatus: false,
            
            exportTypeList: [],
            exportTaskList: [],
            currentExportTask: {},
            exportTaskStatusOptions: [
                {
                    label: '正在执行',
                    value: 0
                },
                {
                    label: '创建导出文件失败',
                    value: 1
                },
                {
                    label: '转储导出文件失败',
                    value: 2
                },
                {
                    label: '上传失败',
                    value: 3
                },
                {
                    label: '已完成',
                    value: 4
                }
            ]
        };
    },
    computed: {
        computeFileSize() {
            return (fileInfo, time) => {
                return FileUtils.computeFileSize(fileInfo.size);
            };
        },
        computeRetryUpload() {
            return (task, time) => {
                return task.status === 3;
            };
        },
        computeShowDownloadBut() {
            return (task, time) => {
                return task.status === 4;
            };
        },
        computeTaskStatus() {
            return (task, time) => {
                switch (task.status) {
                    case 0:
                        return '任务正在执行';
                    case 1:
                        return '创建导出文件失败';
                    case 2:
                        return '转储导出文件失败';
                    case 3:
                        return '保存文件失败';
                    case 4:
                        return '已完成';
                    default:
                        return '未知';
                }
            };
        },
        
        computeFileType() {
            return (fileInfo, time) => {
                let fileName = fileInfo.fileName;
                if (!fileName) {
                    return '未知';
                }
                let splitArr = fileName.split('.');
                if (splitArr.length >= 2) {
                    return splitArr[splitArr.length - 1];
                } else {
                    return '未知';
                }
            };
        }
    },
    created() {
        this.getList();
    },
    methods: {
        handleCopyUrl(url) {
            copyContent(url);
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        /** 查询字典类型列表 */
        getList() {
            this.exportTaskList = [];
            this.loading = true;
            exportTaskApi.queryExportTask(this.queryParams).then(response => {
                    if (response.code === 200) {
                        this.exportTaskList = response.data.result;
                        this.queryParams.total = response.data.total;
                        this.loading = false;
                        this.queryParams.pageNum = response.data.pageNum;
                    } else {
                        this.loading = false;
                    }
                }
            );
            
            exportTaskApi.queryExportTaskTypeList().then(result => {
                if (result.code === 200) {
                    this.exportTypeList = result.data;
                }
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
            this.getList();
        },
        // 表单重置
        reset() {
        
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                
                type: undefined,
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = '文件上传';
            this.updateStatus = false;
            this.currentApiInfo = {};
            this.uploadOpen = true;
            this.currentFileInfo.accessType = 'INTERNAL';
            this.currentFileInfo.ownerType = 'INTERNAL';
        },
        handleBatchDelete() {
        
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.open = true;
            this.title = '修改文件信息';
            this.updateStatus = true;
            this.currentFileInfo = deepCopy(row);
        },
        handleDownloadFile(row) {
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = row.downloadUrl;
            link.target = '_blank';
            link.setAttribute('download', row.fileName);
            document.body.appendChild(link);
            link.click();
        },
        /** 提交按钮 */
        submitForm: function() {
            if (this.updateStatus) {
                fileWebApi.update(this.currentFileInfo).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否删除"' + row.fileName + '"文件？').then(function() {
                return fileWebApi.deleteFile({ id: row.id });
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        handleTerminalTask(task) {
            exportTaskApi.updateExportTask({ id: task.id, terminalStatus: true }).then(result => {
                if (result.code === 200) {
                    message.success('终止任务成功');
                    this.resetQuery();
                }
            });
        },
        createSameExportTask(task) {
            let taskType = task.type;
            let taskDetail = JSON.parse(task.detail);
            if ('EXPORT_TRACK_DATA' === taskType) {
                exportTrackDataApi.createExportTask(taskDetail).then(result => {
                    if (result.code === 200) {
                        message.success('创建成功');
                        this.getList();
                    }
                });
            }
        },
        handleRetryUpload(task) {
            exportTaskApi.retryUpload(task.id).then(result => {
                if (result.code === 200) {
                    message.success('请求成功');
                }
            });
        },
        handleViewDetail(task) {
            this.currentExportTask = deepCopy(task);
            this.currentExportTask.detailJson = JSON.parse(task.detail);
            this.open = true;
        }
    }
};
</script>
<style>
.el-tree {
    min-width: 100%;
    display: inline-block;
}

.tree {
    overflow: auto;
    max-height: 60vh;
}
</style>
